<template>
    <div :class="['ts', 'reveal']" :style="getBg()">
        <div class="tsContainer">
<!--             <div class="sectionTitle black fsTitle">
                <splitter :content="localize(sectionData.title)"></splitter>
            </div>
 -->            <div class="tsBoxes">
                <testimonialboxes
                    :interactive="true" v-bind:items="sectionData.items"
                ></testimonialboxes>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { splitLines,isMobileScreen }         from "@/utils";
import splitter from "@/views/com/splitter.vue";
import testimonialboxes from "@/views/com/testimonialboxes.vue";
import sidepager from "@/views/com/sidepager.vue";

export default 
{
    components:{splitter,testimonialboxes,sidepager},
    data(){
      return {        
        something:[],
        curindex:-1,
        sectionElement:Object      
        }
    },
    props:{
        sectionDataIndex:Number,
        sectionScrollProg:Object
    },
    mounted() 
    {
        var vm = this;
        vm.sectionElement = this.$el;//.querySelector(".wfContainer")[0];
    },
    methods: {
        getBg()
        {
            return "background-image: url('content/mguide/img/bg/bg1.png')";
        },
        addTouchSwipe()
        {
        var vm = this;
        }
    },
    watch: {
        '$store.state.siteVisibleSection': function() {
        var vm=this;
        let _siteVisibleSection = this.$store.state.siteVisibleSection;
        }
    },
    computed: {
        ...mapState(["siteData"]),
        sectionData(){
            return this.siteData.SECTIONS[this.sectionDataIndex];
        }
        //...mapState(["pageLayoutData", "locale", "dirtyHome"]),
    }
};
</script>

<style scoped>
    .ts
    {
        width: 100vw;
        max-height: 100vh;
        height: 100vh;
        overflow: hidden;
        /* background-color: #f9f9f9; */
        padding: 100px 0px;
        background-attachment: fixed;
        background-size:cover;
        background-position:  center center;

    }
    .tsContent
    {
        clear: both;
        width: 100vw;
        margin: auto;
        padding-top: 150px;
    }
    .tsBoxes
    {
        width: 90vw;
        margin: auto;
        top: 60px;
        position: relative;
    }
    @media (hover:hover) {

    }

    @media (max-width: 1200px) { 
        .ts
        {
            padding: 0px 0px;
            position: relative;
            top: 50%;
            transform: translateY(-50%);            
        }     
        .tsBoxes
        {
            top:0px;
        }

    }

    @media (max-width: 850px) { 
        .ts
        {
            max-height: initial;
            height: auto;
            transform: none;
            position: initial;
            background-image: none !important;
        }
        .tsContent
        {
            padding: 0px;
            
        }
    }

    @media (max-width: 400px) { 

    }





    /* Portrait iPad mini 1, iPad 1 and iPad 2*/
    @media only screen 
    and (min-device-width: 768px) 
    and (max-device-width: 1024px) 
    and (-webkit-min-device-pixel-ratio: 1) 
    and (orientation: portrait)
    {
        
    }    
</style>
